import React from 'react';
import '../styling/forms.css';

const DentoalveolarSurgeryForm = ({ dentoalveolarData, handleDentoalveolarChange, handleFormSubmission }) => {
  return (
    <div className="dentoalveolar-checklist">
      <h2>Dentoalveolar Surgery Form</h2>
      <form onSubmit={handleFormSubmission}>
        <label>
          <input
            type="checkbox"
            name="jawFracture"
            checked={dentoalveolarData.jawFracture === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Jaw Fracture
        </label>
        <label>
          <input
            type="checkbox"
            name="alveolarOsteitis"
            checked={dentoalveolarData.alveolarOsteitis === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Alveolar Osteitis
        </label>
        <label>
          <input
            type="checkbox"
            name="sinusExposure"
            checked={dentoalveolarData.sinusExposure === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Sinus Exposure
        </label>
        <label>
          <input
            type="checkbox"
            name="nerveDamage"
            checked={dentoalveolarData.nerveDamage === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Nerve Damage
        </label>
        {dentoalveolarData.nerveDamage === "Yes" && (
          <div className="nerve-damage-type">
            <label htmlFor="nerveDamageType">Specify Nerve Damage Type:</label>
            <input
              type="text"
              name="nerveDamageType"
              value={dentoalveolarData.nerveDamageType}
              onChange={handleDentoalveolarChange}
              placeholder="Enter nerve damage type"
            />
          </div>
        )}
        <label>
          <input
            type="checkbox"
            name="retainedRootTip"
            checked={dentoalveolarData.retainedRootTip === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Retained Root Tip
        </label>
        <label>
          <input
            type="checkbox"
            name="damageAdjacentTeeth"
            checked={dentoalveolarData.damageAdjacentTeeth === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Damage to Adjacent Teeth
        </label>
        <label>
          <input
            type="checkbox"
            name="lipLaceration"
            checked={dentoalveolarData.lipLaceration === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Lip Laceration
        </label>
        <label>
          <input
            type="checkbox"
            name="lipBurn"
            checked={dentoalveolarData.lipBurn === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Lip Burn
        </label>
        <label>
          <input
            type="checkbox"
            name="retainedInstrumentForeignBody"
            checked={dentoalveolarData.retainedInstrumentForeignBody === "Yes"}
            onChange={handleDentoalveolarChange}
          />
          Retained Instrument / Foreign Body
        </label>
        <button type="submit">Submit</button>
      </form>
    </div>
  );
};

export default DentoalveolarSurgeryForm;
